import Input from '@/components/form/Input';
import Select from '@/components/form/Select';

const canadianProvinces = [
  { name: 'Alberta', code: 'AB' },
  { name: 'British Columbia', code: 'BC' },
  { name: 'Manitoba', code: 'MB' },
  { name: 'New Brunswick', code: 'NB' },
  { name: 'Newfoundland and Labrador', code: 'NL' },
  { name: 'Northwest Territories', code: 'NT' },
  { name: 'Nova Scotia', code: 'NS' },
  { name: 'Nunavut', code: 'NU' },
  { name: 'Ontario', code: 'ON' },
  { name: 'Prince Edward Island', code: 'PE' },
  { name: 'Quebec', code: 'QC' },
  { name: 'Saskatchewan', code: 'SK' },
  { name: 'Yukon', code: 'YT' }
];

const AddressFields = () => {
  return (
    <div className="mb-8 space-y-1">
      <h3>Address</h3>
      <Input name="address" label="Address" />
      <Input name="city" label="City" />
      <div className="flex gap-2">
        <div className="w-8/12">
          <Select
            name="stateCode"
            label="Province"
            options={getStateOptions()}
          />
        </div>
        <div className="w-4/12">
          <Input name="zipCode" label="Postal Code" />
        </div>
      </div>
    </div>
  );
};

function getStateOptions() {
  return canadianProvinces.map((province) => ({
    label: province.name,
    value: province.code
  }));
}

export default AddressFields;
